import React from "react";
import { GMBLocation, CustomerOption } from "../types/gmb.types";

interface LocationCardProps {
  location: GMBLocation;
  customers: CustomerOption[];
  selectedCustomerId: string;
  onCustomerChange: (customerId: string) => void;
  onAdd: (location: GMBLocation, customerId: string) => void;
  isConnected: boolean;
  isSaving: boolean;
}

const LocationCard: React.FC<LocationCardProps> = ({
  location,
  customers,
  selectedCustomerId,
  onCustomerChange,
  onAdd,
  isConnected,
  isSaving,
}) => {
  const handleAddClick = () => {
    if (selectedCustomerId) {
      onAdd(location, selectedCustomerId);
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5 flex flex-col hover:border-brand-primary transition-colors shadow-sm">
      <div className="mb-4">
        <h3 className="text-base font-semibold text-gray-900">
          {location.title}
        </h3>
        <p className="text-sm text-gray-600 mt-0.5">{location.address}</p>
        <div className="flex flex-wrap gap-2 mt-1">
          {location.isVerified && (
            <span className="text-[10px] uppercase tracking-wider font-bold text-gray-500 px-2 py-0.5 bg-green-100 text-green-800 rounded">
              Verified
            </span>
          )}
          <span className="text-[10px] font-mono text-gray-400">
            ID: {location.locationId}
          </span>
        </div>
      </div>
      <div className="mt-auto space-y-3">
        {isConnected ? (
          <p className="text-sm font-medium text-green-700 py-2">Connected</p>
        ) : (
          <>
            <div>
              <label className="block text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-1">
                Assign Profile
              </label>
              <select
                value={selectedCustomerId}
                onChange={(e) => onCustomerChange(e.target.value)}
                className="block w-full rounded-lg border border-gray-200 text-xs h-9 px-3 focus:ring-brand-primary focus:border-brand-primary"
              >
                <option value="">-- Select a Business Profile --</option>
                {customers.map((customer) => (
                  <option key={customer.customer_id} value={customer.customer_id}>
                    {customer.name}
                  </option>
                ))}
              </select>
            </div>
            <button
              type="button"
              onClick={handleAddClick}
              disabled={!selectedCustomerId || isSaving}
              className="w-full py-2 text-xs text-white bg-brand-primary rounded-lg font-semibold hover:bg-brand-primary-hover disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm"
            >
              {isSaving ? (
                <span className="flex items-center justify-center gap-1">
                  <span className="animate-spin inline-block w-3 h-3 border-2 border-white border-t-transparent rounded-full" />
                  Connecting...
                </span>
              ) : (
                "Connect"
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default LocationCard;
